<template>
    <section class="onboarding-de onboarding-type-a">
        <div v-if="questionNumber !== numberOfTabs" class="onboarding-header">
            <div class="container">
                <span class="text-big">{{ questionNumber }} / <strong>{{ numberOfTabs }}</strong></span>
            </div>

            <div class="progress-bar">
                <ul class="no-list-style">
                    <li :class="{'active': index <= questionNumber}" v-for="index in numberOfTabs" :key="index"></li>
                </ul>
            </div>
        </div>

        <div class="container">    
            <onboarding-first-question v-if="this.questionNumber === 1"  @clicked="setDataFromChild"></onboarding-first-question>
            <onboarding-second-question v-if="this.questionNumber === 2" :data="apiData" @clicked="setDataFromChild"></onboarding-second-question>
            <onboarding-third-question v-if="this.questionNumber === 3" :data="apiData" @clicked="setDataFromChild"></onboarding-third-question>
            <onboarding-fourth-question v-if="this.questionNumber === 4" :data="apiData" @clicked="setDataFromChild"></onboarding-fourth-question>
            <onboarding-fifth-question v-if="this.questionNumber === 5" :data="apiData" @clicked="setDataFromChild"></onboarding-fifth-question>
            <onboarding-sixth-question v-if="this.questionNumber === 6" :data="apiData" @clicked="setDataFromChild"></onboarding-sixth-question>
            <onboarding-modal-bmi></onboarding-modal-bmi>
        </div>
    </section>
</template>

<script>
import OnboardingFirstQuestion from './OnboardingFirstQuestion'
import OnboardingSecondQuestion from './OnboardingSecondQuestion'
import OnboardingThirdQuestion from './OnboardingThirdQuestion'
import OnboardingFourthQuestion from './OnboardingFourthQuestion'
import OnboardingFifthQuestion from './OnboardingFifthQuestion'
import OnboardingSixthQuestion from './OnboardingSixthQuestion'
import OnboardingModalBmi from './OnboardingModalBMI'

export default {
    components: { 
        OnboardingFirstQuestion,
        OnboardingSecondQuestion,
        OnboardingThirdQuestion,
        OnboardingFourthQuestion,
        OnboardingFifthQuestion,
        OnboardingSixthQuestion,
        OnboardingModalBmi
    },
    data() {
        return {
            questionNumber: 1,
            numberOfTabs: 6,
            submit: false,
            apiData: {
                age: localStorage.getItem("age"),
                height: localStorage.getItem("height"),
                weight: localStorage.getItem("weight"),
                handling_diabetes_self_evaluation: null,
                phone: null,
                phone_country: null,
                learnt_about_vitadio_from: null,
                motivation: localStorage.getItem("motivation"),
                id: localStorage.getItem("form_id"),
                email: localStorage.getItem("email"),
                ga_client_id: null
            }
        }
    },

    watch: {
        questionNumber() {
            var previous = $('#quiz-button-previous')

            if (
                this.questionNumber === 1 || 
                this.questionNumber === 2 || 
                this.questionNumber === 3
                ) {
                previous.show()
            } else {
                previous.hide()
            }

            this.replaceUrl()
        }
    },

    mounted() {
        var that = this
        const uri = new URI(location.href)

        this.replaceUrl()

        $('#quiz-button-previous').click(function () {
            if (that.questionNumber === 1) {
                window.location.replace('/')
            } else {
                that.prevTab()
            }
        })

        if (uri.hasQuery('id')) {
            this.questionNumber = 5
            this.apiData.id = parseInt(uri.search(true).id)
        }

        if (uri.hasQuery('step')) {
            if(parseInt(uri.search(true).step) === 7) {
                this.questionNumber = 6
            } else {
                this.questionNumber = parseInt(uri.search(true).step)
            }
        }
    },

    methods: {
        setDataFromChild(apiData) {     
            if (this.questionNumber === 2) {                        
                this.apiData.motivation = apiData.motivation
                localStorage.setItem("motivation", apiData.motivation)
            }

            if (this.questionNumber === 3) {                        
                this.apiData.age = apiData.age
                localStorage.setItem("age", apiData.age)
                this.apiData.height = apiData.height
                localStorage.setItem("height", apiData.height)
                this.apiData.weight = apiData.weight
                localStorage.setItem("weight", apiData.weight)
            }

            if (this.questionNumber === 4) {           
                this.apiData.email = apiData.email
                localStorage.setItem("email", apiData.email)
                this.apiData.id = apiData.form_id
                localStorage.setItem("form_id", apiData.form_id)
            } 
   
            $('html, body').animate({scrollTop: $("#page").offset().top}, 0)

            this.nextTab()
        },
        prevTab() {
            this.questionNumber = this.questionNumber - 1
        },
        nextTab() {
            this.questionNumber = this.questionNumber + 1
        },
        replaceUrl() {
            var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?step='+this.questionNumber;   
            window.history.replaceState({ path: refresh }, '', refresh);
        }
    }
}
</script>